// export function multiply(a: number, b: number): Promise<number> {
//   return Promise.resolve(a * b);
// }
import React, { useEffect } from 'react';
// import { StyleSheet } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import ProductInfoScreen from '../src/screens/product_info/ProductInfoScreen';
import ProductFormsScreen from '../src/screens/product_forms/ProductFormsScreen';
import PaymentOptionScreen from '../src/screens/payment_option/PaymentOptionScreen';
import SuccessScreen from '../src/components/SuccessScreen';
import ProductListScreen from '../src/screens/product_list/ProductListScreen';
// @ts-ignore
import { useApiKeyStore }  from '../src/store/urlApiKeyStore';

type ProductListProps = {
  apiKey: string; // Adjust the type as per your navigation prop type
};



const McaSDK : React.FC<ProductListProps> = ({ apiKey })  => {

  let {setApiKey, setBaseUrl} = useApiKeyStore();
  useEffect(() => {
    setApiKey(apiKey);
    // setApiKey("MCAPUBK_TEST|1acf339a-d36f-47e7-8e1b-fd0b76b61b0c");
    setBaseUrl();
  },[])

  const Stack = createNativeStackNavigator();
  return(
    <NavigationContainer independent = {true}>
      <Stack.Navigator screenOptions={{ title: "", headerShown: false }} initialRouteName='ProductList'>
        <Stack.Screen
            name='ProductList'
            component={ProductListScreen}
          />
          <Stack.Screen
            name='ProductInfo'
            component={ProductInfoScreen}
          />
          <Stack.Screen
            name='ProductForm'
            component={ProductFormsScreen}
          />
          <Stack.Screen
            name='PaymentOptionScreen'
            component={PaymentOptionScreen}
          />
          <Stack.Screen
            name='SuccessScreen'
            component={SuccessScreen}
          /> 
        </Stack.Navigator>
    </NavigationContainer>
    );
}

export default McaSDK

// const styles = StyleSheet.create({})